import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from '../../Services/AxiosService';
import { CustomStringify } from "../../Helpers/CustomStringify";

export const fetchDataPKRep = createAsyncThunk(
    'PackingChallanReportData/fetchDataPKRep',
    async ({cmpdetail,UserDetail}, { rejectWithValue }) => {

        try {
            const result = await GET(`/purchase/vedorpurchasereport/${cmpdetail?.key}?Party=${encodeURIComponent(UserDetail?.result?.user?.company_name)}`);
            return result;
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || error?.message)
        }
    }
);

const PackingChallanReportDataSlice = createSlice({
    name: 'PackingChallanReportData',
    initialState: {
        result: [],
        status: 'idle',
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDataPKRep.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchDataPKRep.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.result = action.payload;
            })
            .addCase(fetchDataPKRep.rejected, (state, action) => {
                state.status = 'failed';
                state.result = [];
                state.error = action.payload;
            });
    },
});

export default PackingChallanReportDataSlice.reducer;